import css from 'styled-jsx/css';

const styles = css.global`#seguro-auto-cobertura {
    padding-bottom: 80px;
}

#seguro-auto-cobertura picture {
    display: block;
    height: 240px;
}

#seguro-auto-cobertura .img-cobertura {
    width: 100%;
    height: 240px;
    object-fit: cover;
    object-position: top;
}

#seguro-auto-cobertura .cobertura-contain {
    margin-top: 32px;
}

#seguro-auto-cobertura .cobertura-contain .cobertura-titulo {
    color: #C00;
    font-family: "SantanderHeadline";
    font-size: 40px;
    font-style: normal;
    font-weight: 400;
    line-height: 60px;
}

#seguro-auto-cobertura .cobertura-contain .coberturas {
    margin-top: 16px;
    color: #444;
    font-family: "SantanderText";
    font-size: 18px;
    font-style: normal;
    font-weight: 400;
    line-height: 28px;
    list-style-position: inside;
    padding-left: 10px;
}

#seguro-auto-cobertura .cobertura-contain .coberturas li::marker {
    font-size: 14px;
}

#seguro-auto-cobertura .cobertura-contain .cobertura-texto {
    margin-top: 16px;
    color: #444;
    font-family: "SantanderText";
    font-size: 18px;
    font-style: normal;
    font-weight: 400;
    line-height: 28px;
}

#seguro-auto-cobertura .cobertura-contain .btn-cobertura {
    width: 100%;
    max-width: 272px;
    height: 48px;
    margin: 32px auto 0;
}

@media (min-width: 992px) {
    #seguro-auto-cobertura {
        padding: 64px 0;
    }

    #seguro-auto-cobertura .ctn-home-24 {
        display: flex;
        align-items: center;
        gap: 72px;
    }

    #seguro-auto-cobertura picture {
        height: 497px;
    }

    #seguro-auto-cobertura .img-cobertura {
        width: 525px;
        height: 497px;
        border-radius: 4px;
        margin-left: -47px;
    }

    #seguro-auto-cobertura .cobertura-contain .cobertura-titulo {
        max-width: 496px;
    }

    #seguro-auto-cobertura .cobertura-contain .coberturas  {
        margin-top: 36px;
        display: flex;
        flex-wrap: wrap;
        width: 330px;
        gap: 8px 23px;
        padding: 0;
    }

    #seguro-auto-cobertura .cobertura-contain .coberturas li {
        width: 150px;
    }

    #seguro-auto-cobertura .cobertura-contain .cobertura-texto {
        margin-top: 32px;
        max-width: 453px;
    }
    
    #seguro-auto-cobertura .cobertura-contain .btn-cobertura {
        margin: 32px 0 0;
    }
    
}`;

export default styles;